export default "__VITE_ASSET__BxohP$YT__"